"use strict";
var appn;
(function (appn) {
    var utils;
    (function (utils) {
        utils.getKeyValue = (key) => (obj) => obj[key];
        utils.getKeyValue2 = (obj) => (key) => obj[key];
        function hasValue(param) {
            if (typeof param === 'number' && param === 0)
                return true;
            if (param instanceof jQuery)
                return $(param).length > 0;
            if (typeof param === 'object')
                return !$.isEmptyObject(param);
            if (typeof param === 'undefined')
                return false;
            return !(!param);
        }
        utils.hasValue = hasValue;
        function hasValues(...params) {
            if (!params || params.length === 0)
                return false;
            return _.every(params, utils.hasValue);
        }
        utils.hasValues = hasValues;
        function isIn(value, ...inValues) {
            if (!hasValue(value) || !hasValue(inValues))
                return false;
            return _.some(inValues, v => v === value);
        }
        utils.isIn = isIn;
        function isWholeNumber(value) {
            return /^-{0,1}\d+$/.test(value);
        }
        utils.isWholeNumber = isWholeNumber;
        function isValidEmailAddress(emailAddress) {
            const pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
            return pattern.test(emailAddress);
        }
        utils.isValidEmailAddress = isValidEmailAddress;
        function newGuid(excludeDashes) {
            const s4 = function () {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            };
            if (excludeDashes)
                return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        }
        utils.newGuid = newGuid;
        function newUniqueId() {
            const guid = newGuid(true);
            return guid.substring(0, 3);
        }
        utils.newUniqueId = newUniqueId;
        function normalizeIdentifier(id) {
            if (!id)
                return '';
            return id.toLowerCase().replace(/-/g, '');
        }
        utils.normalizeIdentifier = normalizeIdentifier;
        function arrayRemove(array, from, to) {
            const rest = array.slice((to || from) + 1 || array.length);
            array.length = from < 0 ? array.length + from : from;
            return array.push.apply(array, rest);
        }
        utils.arrayRemove = arrayRemove;
        function getUrlParamByName(name, url) {
            if (!url)
                url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
            if (!results)
                return null;
            if (!results[2])
                return appn.emptyString;
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
        utils.getUrlParamByName = getUrlParamByName;
        function isValidFileExtension(validExtensions, fileName) {
            if (!fileName || !validExtensions || validExtensions.length === 0)
                return false;
            let isValidExtension = false;
            $(validExtensions).each(function (ii, fileExtension) {
                if (fileName.trim().toLowerCase().endsWithIgnoreCase(fileExtension.toLowerCase())) {
                    isValidExtension = true;
                    return false;
                }
                return true;
            });
            if (!isValidExtension) {
                appn.dialog.alert({
                    modalColor: 'modal-danger',
                    title: T('Invalid File Format'),
                    message: T('{0} is not allowed.<br>Only the following file extensions are permitted:', fileName) + '<br><b>' + validExtensions.join(',') + '</b>'
                });
                return false;
            }
            return true;
        }
        utils.isValidFileExtension = isValidFileExtension;
        function IsValidFileSize(maxAllowedFileSize, file) {
            if (!maxAllowedFileSize || !file)
                return false;
            const sizeKb = (file.size || file.fileSize) / 1024;
            if (sizeKb > maxAllowedFileSize) {
                appn.dialog.alert({
                    modalColor: 'modal-danger',
                    title: T('Max File Size Exceeded'),
                    message: T('The maximum image size allowed is {0} kilobytes. Use an image editor to resize your image, and please ensure that the replacement icon image is 192 x 192 pixels in dimension.', maxAllowedFileSize.toString())
                });
                return false;
            }
            return true;
        }
        utils.IsValidFileSize = IsValidFileSize;
        function deepClone(obj) {
            if (obj === null || typeof obj !== 'object')
                return obj;
            if (Array.isArray(obj)) {
                const arrCopy = [];
                for (let i = 0; i < obj.length; i++)
                    arrCopy[i] = deepClone(obj[i]);
                return arrCopy;
            }
            const objCopy = {};
            for (const key in obj) {
                if (obj.hasOwnProperty(key))
                    objCopy[key] = deepClone(obj[key]);
            }
            return objCopy;
        }
        utils.deepClone = deepClone;
        function cloneTemplate(templateId, throwIfNotFound = true) {
            const templateElement = document.getElementById(templateId);
            if (templateElement)
                return $(templateElement.content.cloneNode(true)).children();
            if (throwIfNotFound)
                throw new Error(`Template not found for id: ${templateId}`);
            return $();
        }
        utils.cloneTemplate = cloneTemplate;
        function isGreaterThanTimeOrDate(a, b) {
            let parsedA = new Date(a).getTime();
            let parsedB = new Date(b).getTime();
            if (!Number.isNaN(parsedA) && !Number.isNaN(parsedB))
                return parsedA > parsedB;
            parsedA = (new Date('1970-01-01 ' + a)).getTime();
            parsedB = (new Date('1970-01-01 ' + b)).getTime();
            if (!Number.isNaN(parsedA) && !Number.isNaN(parsedB))
                return parsedA > parsedB;
            appn.log.error(`Time or dateTime inputs a: ${a} or b: ${b} were malformed`, true);
            return false;
        }
        utils.isGreaterThanTimeOrDate = isGreaterThanTimeOrDate;
        function isValidUrl(val) {
            if (!hasValue(val))
                return false;
            let url;
            try {
                url = new URL(val);
            }
            catch (_) {
                return false;
            }
            return url.protocol === 'http:' || url.protocol === 'https:';
        }
        utils.isValidUrl = isValidUrl;
        function isValidMapTileSourceUrl(val) {
            if (!hasValue(val))
                return false;
            if (!(val === null || val === void 0 ? void 0 : val.startsWithIgnoreCase('http')))
                return true;
            if (!(val === null || val === void 0 ? void 0 : val.contains('{z}')) || !(val === null || val === void 0 ? void 0 : val.contains('{x}')) || !(val === null || val === void 0 ? void 0 : val.contains('{y}')))
                return false;
            const urlClean = val.replace('{', '').replace('}', '');
            return isValidUrl(urlClean);
        }
        utils.isValidMapTileSourceUrl = isValidMapTileSourceUrl;
        function upperCaseFirst(input) {
            if (!input || input.length === 0)
                return appn.emptyString;
            return input.charAt(0).toUpperCase() + input.slice(1);
        }
        utils.upperCaseFirst = upperCaseFirst;
        function shake(element) {
            element.addClass('headshake');
            setTimeout(function () {
                element.removeClass('headshake');
            }, 820);
        }
        utils.shake = shake;
        function MD5Unicode(buffer) {
            var MD5 = function (d) {
                return M(V(Y(X(d), 8 * d.length)));
            };
            function M(d) {
                for (var _, m = '0123456789abcdef', f = '', r = 0; r < d.length; r++) {
                    _ = d.charCodeAt(r);
                    f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
                }
                return f;
            }
            function X(d) {
                for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) {
                    _[m] = 0;
                }
                for (m = 0; m < 8 * d.length; m += 8) {
                    _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
                }
                return _;
            }
            function V(d) {
                for (var _ = '', m = 0; m < 32 * d.length; m += 8)
                    _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
                return _;
            }
            function Y(d, _) {
                d[_ >> 5] |= 128 << _ % 32;
                d[14 + (_ + 64 >>> 9 << 4)] = _;
                for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
                    var h = m;
                    var t = f;
                    var g = r;
                    var e = i;
                    f = md5ii(f = md5ii(f = md5ii(f = md5ii(f = md5hh(f = md5hh(f = md5hh(f = md5hh(f = md5gg(f = md5gg(f = md5gg(f = md5gg(f = md5ff(f = md5ff(f = md5ff(f = md5ff(f, r = md5ff(r, i = md5ff(i, m = md5ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5ff(r, i = md5ff(i, m = md5ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5ff(r, i = md5ff(i, m = md5ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5ff(r, i = md5ff(i, m = md5ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5gg(r, i = md5gg(i, m = md5gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5gg(r, i = md5gg(i, m = md5gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5gg(r, i = md5gg(i, m = md5gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5gg(r, i = md5gg(i, m = md5gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5hh(r, i = md5hh(i, m = md5hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5hh(r, i = md5hh(i, m = md5hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5hh(r, i = md5hh(i, m = md5hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5hh(r, i = md5hh(i, m = md5hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5ii(r, i = md5ii(i, m = md5ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5ii(r, i = md5ii(i, m = md5ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5ii(r, i = md5ii(i, m = md5ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5ii(r, i = md5ii(i, m = md5ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551);
                    m = safeadd(m, h);
                    f = safeadd(f, t);
                    r = safeadd(r, g);
                    i = safeadd(i, e);
                }
                return [m, f, r, i];
            }
            function md5cmn(d, _, m, f, r, i) {
                return safeadd(bitrol(safeadd(safeadd(_, d), safeadd(f, i)), r), m);
            }
            function md5ff(d, _, m, f, r, i, n) {
                return md5cmn(_ & m | ~_ & f, d, _, r, i, n);
            }
            function md5gg(d, _, m, f, r, i, n) {
                return md5cmn(_ & f | m & ~f, d, _, r, i, n);
            }
            function md5hh(d, _, m, f, r, i, n) {
                return md5cmn(_ ^ m ^ f, d, _, r, i, n);
            }
            function md5ii(d, _, m, f, r, i, n) {
                return md5cmn(m ^ (_ | ~f), d, _, r, i, n);
            }
            function safeadd(d, _) {
                var m = (65535 & d) + (65535 & _);
                return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m;
            }
            function bitrol(d, _) {
                return d << _ | d >>> 32 - _;
            }
            if (!(buffer instanceof Uint8Array)) {
                buffer = new TextEncoder().encode(typeof buffer === 'string' ? buffer : JSON.stringify(buffer));
            }
            var binary = Array();
            var bytes = new Uint8Array(buffer);
            for (var i = 0, il = bytes.byteLength; i < il; i++) {
                binary.push(String.fromCharCode(bytes[i]));
            }
            return MD5(binary.join(''));
        }
        utils.MD5Unicode = MD5Unicode;
        ;
        class RgbColor {
            constructor(red, green, blue) {
                this.red = red;
                this.green = green;
                this.blue = blue;
            }
            toString() {
                return `rgb(${this.red}, ${this.green}, ${this.blue});`;
            }
        }
        utils.RgbColor = RgbColor;
        class ColorPalette {
            constructor() {
                this.white = {
                    hex: '#FFFFFF',
                    rgb: new RgbColor(255, 255, 255)
                };
                this.greyLight = {
                    hex: '#EEEEEE',
                    rgb: new RgbColor(238, 238, 238)
                };
                this.grey = {
                    hex: '#7B7B7B',
                    rgb: new RgbColor(123, 123, 123)
                };
                this.black = {
                    hex: '#333333',
                    rgb: new RgbColor(51, 51, 51)
                };
                this.blackDark = {
                    hex: '#222222',
                    rgb: new RgbColor(34, 34, 34)
                };
            }
        }
        utils.ColorPalette = ColorPalette;
        String.prototype.contains = function (stringToFind) {
            return this.indexOf(stringToFind) !== -1;
        };
        String.prototype.containsIgnoreCase = function (stringToFind) {
            return this.toLowerCase().indexOf(stringToFind.toLowerCase()) !== -1;
        };
        String.prototype.endsWithIgnoreCase = function (stringToFind, dontTrim) {
            if (dontTrim)
                return this.toLowerCase().endsWith(stringToFind.toLowerCase());
            return this.trim().toLowerCase().endsWith(stringToFind.trim().toLowerCase());
        };
        String.prototype.startsWithIgnoreCase = function (stringToFind, dontTrim) {
            if (dontTrim)
                return this.toLowerCase().startsWith(stringToFind.toLowerCase());
            return this.trim().toLowerCase().startsWith(stringToFind.trim().toLowerCase());
        };
        String.prototype.hasValue = function () {
            if (this === null || this === undefined)
                return false;
            return this.trim() !== appn.emptyString;
        };
        String.prototype.AsJSON = function () {
            if (this === null || this === undefined)
                return {};
            return JSON.parse(this.toString());
        };
        String.prototype.IsJSON = function () {
            try {
                if (this.toString())
                    JSON.parse(this.toString());
                else
                    return false;
            }
            catch (e) {
                return false;
            }
            return true;
        };
        String.prototype.toHtmlElement = function () {
            const dom = document.createElement('div');
            dom.innerHTML = this.toString();
            return dom;
        };
        String.prototype.toBoolean = function () {
            if (this.toLowerCase() === 'true')
                return true;
            if (this.toLowerCase() === 'false')
                return false;
        };
        String.prototype.toBooleanExact = function () {
            if (this.toLowerCase() === 'true')
                return true;
            if (this.toLowerCase() === 'false')
                return false;
            return false;
        };
        $.distinct = function (array) {
            return array.filter((o, i, s) => {
                return s.indexOf(o) === i;
            });
        };
        $.arrayContains = function (array, value) {
            if (array.indexOf(value) > -1)
                return true;
            return false;
        };
        $.fn.hideElement = function () {
            if (!this)
                return this;
            this.each((index, element) => {
                const $this = $(element);
                if (!$this.attr('class'))
                    return;
                let oldclasses = [];
                let oldDisplayClasses = [];
                if ($this.data('oldclasses')) {
                    oldclasses = $this.data('oldclasses').split(' ').filter((oldClassItem) => {
                        return (hasValue(oldClassItem) && oldClassItem !== 'd-none' && !oldClassItem.startsWithIgnoreCase('d-'));
                    });
                    oldDisplayClasses = $this.data('oldclasses').split(' ').filter((oldClassItem) => {
                        return (hasValue(oldClassItem) && oldClassItem !== 'd-none' && oldClassItem.startsWithIgnoreCase('d-'));
                    });
                }
                const classes = $this.attr('class').split(' ').filter((classItem) => {
                    return (hasValue(classItem) && classItem !== 'd-none' && !classItem.startsWithIgnoreCase('d-'));
                });
                const displayClasses = $this.attr('class').split(' ').filter((classItem) => {
                    return (hasValue(classItem) && classItem !== 'd-none' && classItem.startsWithIgnoreCase('d-'));
                });
                const newClasses = _.union(oldclasses, classes);
                const newDisplayClasses = _.union(oldDisplayClasses, displayClasses);
                if (newDisplayClasses.length > 0) {
                    $this.attr('data-oldclasses', newDisplayClasses.join(' '));
                    newDisplayClasses.forEach((cls) => {
                        $this.removeClass(cls);
                    });
                }
                $this.attr('class', newClasses.join(' ') + ' d-none');
            });
            return this;
        };
        $.fn.showElement = function () {
            if (!this)
                return this;
            this.each((index, element) => {
                const $this = $(element);
                if (!$this.attr('class'))
                    return;
                let oldDisplayclasses = [];
                if ($this.data('oldclasses'))
                    oldDisplayclasses = $this.data('oldclasses').split(' ').filter((oldClassItem) => {
                        return hasValue(oldClassItem);
                    });
                let classes = $this.attr('class').split(' ').filter((classItem) => {
                    return hasValue(classItem);
                });
                classes = _.union(classes, oldDisplayclasses);
                $this.attr('class', $.distinct(classes.filter((o) => {
                    return o !== 'd-none';
                })).join(' '));
                $this.removeAttr('data-oldclasses');
            });
            return this;
        };
        utils.isUnloading = false;
        utils.isAppnScriptLoaded = false;
        utils.mapLoadState = "";
        addEventListener('unload', () => {
            utils.isUnloading = true;
        });
        appn.pubSub.subscribe(appn.pubSub.APPN_READY, () => {
            setTimeout(() => {
                utils.isAppnScriptLoaded = true;
            }, 0);
        });
    })(utils = appn.utils || (appn.utils = {}));
})(appn || (appn = {}));
(function (appn) {
    var validate;
    (function (validate) {
        function init() {
            $(document).on('change', '.input-group[data-validationstate] .editorTextfield', (e) => {
                $(e.target).closest('.input-group').attr('data-validationstate', 'edited');
            });
        }
        validate.init = init;
    })(validate = appn.validate || (appn.validate = {}));
})(appn || (appn = {}));
